// LIBRARIES
// @ts-nocheck
import styled from "styled-components";

// MISC
import { COLORS, BOXSHADOW, FONTS, WIDTH } from "constants/styleVariables";
import LoginPicture from "../../assets/LoginAssets/BACKGROUND.png";

export const AuthenticateContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  height: 100vh;
  background-size: cover;
  background-image: url(${LoginPicture});
  background-color: #EBEBEB;
  margin-left: 340px;
  overflow-x: hidden;
  overflow-y: hidden;
  
`;

export const FormWrapper = styled.div`
  position: absolute;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items:center;
  width: 888px;
  min-width: 280px;
  height: 100%;
  min-height: 600px;
  padding: 120px 80px;
  background: #F5F5F5;
  border-top-right-radius: 25px 25px;
  border-bottom-right-radius: 25px 25px;
  @media (${WIDTH.tabletWidth}) {
    width: 100%;
    height: 100%;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  opacity: 1;
  overflow-x: hidden;
  overflow-y: hidden;
`;

export const SupIconImage = styled.img`
  @media screen and (max-width: 1099px) {
    width: 176px;
    height: 89px;
  }
  @media screen and (max-width: 1599px) and (min-width: 1100px) {
    width: 276px;
    height: 89px;
  }
  @media screen and (min-width: 1600px) {
    width: 276px;
    height: 89px;
  }
  width: 276px;
  height: 89px;
  margin: 0 auto;
  overflow-x: hidden;
  overflow-y: hidden;
`;
export const LoginImage = styled.div``;
export const WelcomeTitle = styled.h5`
  margin-top: 80px;
  font-size: 26px;
  font-weight: medium;
  font-family: ${FONTS.poppins};
  color: #1D1D26;
  margin-bottom: 32px;
`;
export const CenteredElementsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;
export const ButtonContainer = styled.div`
  // margin: 80px auto 0 auto;
`;

export const ImageContainer = styled.div`
  width: 65%;
  height: 100%;
`;
export const AuthenticatePicture = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
export const InputContainer = styled.div`
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
`;
export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
`;
export const BackgrounImageContainer = styled.div`
  width: 70%;
  min-width: 450px;
  min-height: 600px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const ProjectDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 70%;
  background: ${COLORS.forthWhite};
  margin: auto 0;
`;
export const PhotosContainer = styled.div`
  width: 63%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 45px;
`;
export const PhotoContainer = styled.img``;
export const DescriptionContainer = styled.div`
  @media screen and (max-width: 1099px) {
    font-size: 12px;
  }
  @media screen and (max-width: 1599px) and (min-width: 1100px) {
    font-size: 16px;
  }
  @media screen and (min-width: 1600px) {
    font-size: 20px;
  }
  width: 63%;
  font-family: ${FONTS.montserrat};
  font-weight: 600;
  color: ${COLORS.rainbowIndigo};
`;
export const TextContainer = styled.div`
  margin-bottom: 20px;
`;

export const ForgotPassword = styled.div`
  text-decoration: underline;
  cursor: pointer;
  letter-spacing: 0.24px;
  color: #E65847;
  font-size: 12px;
  text-align: center;
  margin-top: 16px;
`
